import { createFileRoute } from '@tanstack/react-router'

import PagePlaygroundComposition from '../pages/PagePlaygroundComposition'

type PlaygroundRunSearch = {
  runId?: string
}

export const Route = createFileRoute('/playground/composition')({
  component: PagePlaygroundComposition,
  validateSearch: (search: Record<string, unknown>): PlaygroundRunSearch => ({
    runId: typeof search.runId === 'string' && search.runId.length > 0 ? search.runId : undefined
  })
})
